import { getShortYearString } from "../helpers/stringHelper";
import type { Apprentice } from "./apprentice";
import type { Coach } from "./coach";
import type { Occupation } from "./enums/occupation";
import type { YearContext } from "./yearContext";

export type Group = {
  id: number;
  name: string;
  year_context: YearContext;
  coach: Coach;
  occupation: Occupation;
  apprentices: Apprentice[];
};

export function getGroupOptions(groups: Group[], withYear = true) {
  return groups.map((g) => ({ label: `${g.name} ${withYear ? `(${getShortYearString(g.year_context)})` : ""}`, value: g.id.toString() }));
}
